import axios from 'axios'
import { CADASTRAR_DISPONIBILIDADE_VEICULO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function salvarDisponibilidadeVeiculo (disponibilidadeVeiculo) {
  const url = `${URL}/disponibilidade-veiculo/salvar`;
  return dispatch => axios.post(url,disponibilidadeVeiculo , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_DISPONIBILIDADE_VEICULO,
        payload: response
      })
  );
}
